import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import loginBanner from "../../assets/banner/loginBanner.png";
import * as Yup from "yup";
import * as UserServices from "../../Services/UserServices";
import * as Alert from "../../components/common/Alert";
import { jwtDecode } from "jwt-decode";

const VendorLogin = () => {
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      phone_number: "",
      otp: "",
    },
    validationSchema: Yup.object().shape({
      phone_number: Yup.string().matches(
        /^\d{10}$/,
        "Phone Number must be 10 digits"
      ),
    }),
    onSubmit: (values) => {
      if (!values.otp && values.phone_number) {
        UserServices.sendOtpForLogin(values).then((response) => {
          if (response.status === 200) {
            setIsPhoneVerified(true);
            Alert.Alert.SuccessAlert("OTP sent successfully");
          } else {
          }
        });
      } else if (isPhoneVerified && values.otp && values.phone_number) {
        UserServices.LoginApi(values)
          .then((response) => {
            if (response.status === 200) {
              const accessToken = response.data.data.access;
              const refreshToken = response.data.data.refresh;

              // 🔓 Decode the token
              const decoded = jwtDecode(accessToken);

              // ✅ Extract role (assuming it's something like decoded.role or decoded.user_type)
              // const userRole = decoded.role || decoded.user_type || null;
              // if (userRole) {
              //   localStorage.setItem('user_role', userRole);
              // }

              // Store tokens
              localStorage.setItem("access_token", accessToken);
              localStorage.setItem("refresh_token", refreshToken);

              Alert.Alert.SuccessAlert("Login successful");
              navigate("/vendor-home");
            } else {
              Alert.Alert.ErrorAlert("Invalid OTP or login failed");
            }
          })
          .catch((err) => {
            Alert.Alert.ErrorAlert("Something went wrong during login");
          });
      }
    },
  });

  return (
    <div className="flex flex-col lg:flex-row ">
      <div className="w-100 lg:w-1/2">
        <div className="flex justify-center">
          <img
            loading="lazy"
            src={loginBanner}
            alt="Login Banner"
            className="h-[88vh] lg:w-[50vw]"
          />
        </div>
      </div>
      <div className="w-100 lg:w-1/2 flex justify-center md:justify-start items-center overflow-y-auto">
        <div className="w-100 px-[5vh] md:px-[10vh] lg:px-[15vh] py-5">
          <h6 className="fw-bold text-xl md:text-2xl lg:text-4xl">
            Login as Vendor
          </h6>
          <p className="text-gray-500 mt-1">Let’s Start with Log in</p>
          <form onSubmit={formik.handleSubmit} className="xl:pr-5 mt-5">
            <div>
              <label className="text-lg lg:text-xl">Phone Number</label>
              <input
                type="number"
                name="phone_number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone_number}
                className="form-control mt-2"
                placeholder="Enter Mobile Number"
              />
              {formik.touched.phone_number && formik.errors.phone_number && (
                <p className="text-danger text-sm px-2">
                  {formik.errors.phone_number}
                </p>
              )}
            </div>
            {formik.values.phone_number && isPhoneVerified && (
              <div className="mt-3">
                <label className="text-lg lg:text-xl">OTP</label>
                <input
                  type="text"
                  name="otp"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.otp}
                  className="form-control mt-2"
                  placeholder="Enter OTP"
                />
                {formik.touched.otp && formik.errors.otp && (
                  <p className="text-danger text-sm px-2">
                    {formik.errors.otp}
                  </p>
                )}
              </div>
            )}
            <div className="mt-5">
              <button type="submit" className="btn theme-outline-btn w-100">
                Login
              </button>
            </div>
          </form>
          <Link
            to="/vendor-registration"
            className="text-blue-600 underline mt-4 flex items-center gap-1"
          >
            New here? Register as Vendor!
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VendorLogin;
